__turbopack_context__.v({
  "addedToCartFooterRow": "BloodVisionUpsellModal-module__R77P8G__addedToCartFooterRow",
  "aeCityList": "BloodVisionUpsellModal-module__R77P8G__aeCityList",
  "aeCityOption": "BloodVisionUpsellModal-module__R77P8G__aeCityOption",
  "closeButton": "BloodVisionUpsellModal-module__R77P8G__closeButton",
  "descriptionSection": "BloodVisionUpsellModal-module__R77P8G__descriptionSection",
  "descriptionText": "BloodVisionUpsellModal-module__R77P8G__descriptionText",
  "detailItem": "BloodVisionUpsellModal-module__R77P8G__detailItem",
  "detailItemDescription": "BloodVisionUpsellModal-module__R77P8G__detailItemDescription",
  "detailItemTitle": "BloodVisionUpsellModal-module__R77P8G__detailItemTitle",
  "detailsList": "BloodVisionUpsellModal-module__R77P8G__detailsList",
  "divider": "BloodVisionUpsellModal-module__R77P8G__divider",
  "finalAddToCartButton": "BloodVisionUpsellModal-module__R77P8G__finalAddToCartButton",
  "headerInfo": "BloodVisionUpsellModal-module__R77P8G__headerInfo",
  "headerPrice": "BloodVisionUpsellModal-module__R77P8G__headerPrice",
  "headerSection": "BloodVisionUpsellModal-module__R77P8G__headerSection",
  "inlinePricingNote": "BloodVisionUpsellModal-module__R77P8G__inlinePricingNote",
  "innerTitle": "BloodVisionUpsellModal-module__R77P8G__innerTitle",
  "innerTitleRow": "BloodVisionUpsellModal-module__R77P8G__innerTitleRow",
  "inputLoader": "BloodVisionUpsellModal-module__R77P8G__inputLoader",
  "modalAddedToCartDisclaimer": "BloodVisionUpsellModal-module__R77P8G__modalAddedToCartDisclaimer",
  "modalContainer": "BloodVisionUpsellModal-module__R77P8G__modalContainer",
  "modalContent": "BloodVisionUpsellModal-module__R77P8G__modalContent",
  "pincodeInput": "BloodVisionUpsellModal-module__R77P8G__pincodeInput",
  "pincodeInputShell": "BloodVisionUpsellModal-module__R77P8G__pincodeInputShell",
  "pricingInfoTrigger": "BloodVisionUpsellModal-module__R77P8G__pricingInfoTrigger",
  "productName": "BloodVisionUpsellModal-module__R77P8G__productName",
  "staticSectionTitle": "BloodVisionUpsellModal-module__R77P8G__staticSectionTitle",
  "statusText": "BloodVisionUpsellModal-module__R77P8G__statusText",
  "stickyFooter": "BloodVisionUpsellModal-module__R77P8G__stickyFooter",
  "thumbnailContainer": "BloodVisionUpsellModal-module__R77P8G__thumbnailContainer",
  "usPricingDisclaimer": "BloodVisionUpsellModal-module__R77P8G__usPricingDisclaimer",
});
